import React from 'react';

import { Autocomplete, Popper, styled, type PopperProps } from '@mui/material';
import { Controller } from 'react-hook-form';

import Input from './Input';
import { type ControlledAutocompleteProps } from './types';

const StyledInput = styled(Input)`
    padding-right: 3rem;

    .MuiAutocomplete-endAdornment {
        right: 7px;
    }
`;

const FitContentPopper = (props: PopperProps) => <Popper {...props} placement={'bottom-end'} />;

export const ControlledAutocomplete: React.FC<ControlledAutocompleteProps> = (props) => (
    <Controller
        name={props.name}
        control={props.control}
        defaultValue={props.defaultValue}
        render={({ field, fieldState }) => (
            <Autocomplete
                {...props}
                isOptionEqualToValue={(option, value) => {
                    if (typeof option === 'object' && typeof value === 'object') {
                        return option.value === value.value;
                    }
                    return option === value;
                }}
                onChange={(e, value) => field.onChange(value instanceof Object ? value.value : value)}
                value={field.value}
                options={props.options}
                PopperComponent={FitContentPopper}
                renderInput={(params) => (
                    <div ref={params.InputProps.ref} className={props.className}>
                        <StyledInput
                            name={props.name}
                            label={props.label}
                            inputProps={params.inputProps}
                            error={!!fieldState.error?.message}
                            endAdornment={params.InputProps.endAdornment}
                            fullWidth={params.fullWidth}
                        />
                    </div>
                )}
            />
        )}
    />
);

export default ControlledAutocomplete;
